// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_lc-1";
export var quotedThread = "_lc-0";